export const varMappings = {
  'token-alphalight-100': 'var(--token-color-alphalight-100)',
  'token-alphalight-200': 'var(--token-color-alphalight-200)',
  'token-alphalight-300': 'var(--token-color-alphalight-300)',
  'token-alphalight-400': 'var(--token-color-alphalight-400)',
  'token-alphalight-500': 'var(--token-color-alphalight-500)',
  'token-alphalight-700': 'var(--token-color-alphalight-700)',
  'token-gray-100': 'var(--token-color-gray-100)',
  'token-gray-200': 'var(--token-color-gray-200)',
  'token-gray-300': 'var(--token-color-gray-300)',
  'token-gray-400': 'var(--token-color-gray-400)',
  'token-gray-500': 'var(--token-color-gray-500)',
  'token-gray-600': 'var(--token-color-gray-600)',
  'token-gray-700': 'var(--token-color-gray-700)',
  'token-gray-800': 'var(--token-color-gray-800)',
  'token-gray-900': 'var(--token-color-gray-900)',
  'token-gray-1000': 'var(--token-color-gray-1000)',
  'token-gray-1200': 'var(--token-color-gray-1200)',
  'token-gray-1600': 'var(--token-color-gray-1600)',
  'token-green-100': 'var(--token-color-green-100)',
  'token-green-300': 'var(--token-color-green-300)',
  'token-green-400': 'var(--token-color-green-400)',
  'token-green-900': 'var(--token-color-green-900)',
  'token-green-1000': 'var(--token-color-green-1000)',
  'token-green-1100': 'var(--token-color-green-1100)',
  'token-green-1200': 'var(--token-color-green-1200)',
  'token-orange-200': 'var(--token-color-orange-200)',
  'token-orange-300': 'var(--token-color-orange-300)',
  'token-orange-400': 'var(--token-color-orange-400)',
  'token-orange-500': 'var(--token-color-orange-500)',
  'token-orange-900': 'var(--token-color-orange-900)',
  'token-orange-1100': 'var(--token-color-orange-1100)',
  'token-purple-200': 'var(--token-color-purple-200)',
  'token-purple-300': 'var(--token-color-purple-300)',
  'token-purple-400': 'var(--token-color-purple-400)',
  'token-purple-500': 'var(--token-color-purple-500)',
  'token-purple-600': 'var(--token-color-purple-600)',
  'token-purple-900': 'var(--token-color-purple-900)',
  'token-purple-1000': 'var(--token-color-purple-1000)',
  'token-purple-1100': 'var(--token-color-purple-1100)',
  'token-red-200': 'var(--token-color-red-200)',
  'token-red-300': 'var(--token-color-red-300)',
  'token-red-400': 'var(--token-color-red-400)',
  'token-red-600': 'var(--token-color-red-600)',
  'token-red-900': 'var(--token-color-red-900)',
  'token-red-1000': 'var(--token-color-red-1000)',
  'token-red-1300': 'var(--token-color-red-1300)',
  'special-background-app': 'var(--token-color-special-background-app)',
  'special-content-select-button-primary':
    'var(--token-color-special-content-select-button-primary)',
  'special-content-button-primary-black': 'var(--token-color-special-content-button-primary-black)',
  'special-background-button-medium-secondary':
    'var(--token-color-special-background-button-medium-secondary)',
  'special-background-button-medium-secondary-hover':
    'var(--token-color-special-background-button-medium-secondary-hover)',
  'special-background-button-medium-secondary-pressed':
    'var(--token-color-special-background-button-medium-secondary-pressed)',
  'special-background-button-red-primary':
    'var(--token-color-special-background-button-red-primary)',
  'special-background-button-red-primary-hover':
    'var(--token-color-special-background-button-red-primary-hover)',
  'special-background-button-red-primary-pressed':
    'var(--token-color-special-background-button-red-primary-pressed)',
  'special-background-button-red-secondary':
    'var(--token-color-special-background-button-red-secondary)',
  'special-background-button-red-secondary-hover':
    'var(--token-color-special-background-button-red-secondary-hover)',
  'special-background-button-red-secondary-pressed':
    'var(--token-color-special-background-button-red-secondary-pressed)',
  'special-background-button-purple': 'var(--token-color-special-background-button-purple)',
  'special-background-button-purple-hover':
    'var(--token-color-special-background-button-purple-hover)',
  'special-background-button-purple-pressed':
    'var(--token-color-special-background-button-purple-pressed)',
  'special-background-button-switch': 'var(--token-color-special-background-button-switch)',
  'special-background-button-tokens': 'var(--token-color-special-background-button-tokens)',
  'special-background-homepage': 'var(--token-color-special-background-homepage)',
  'special-background-modal': 'var(--token-color-special-background-modal)',
  'special-background-navbar': 'var(--token-color-special-background-navbar)',
  'special-background-overlay': 'var(--token-color-special-background-overlay)',
  'special-background-tooltip': 'var(--token-color-special-background-tooltip)',
  'special-background-card': 'var(--token-color-special-background-card)',
  'special-border-avatar': 'var(--token-color-special-border-avatar)',
  'special-border-avatar-mask': 'var(--token-color-special-border-avatar-mask)',
  'special-border-button-tokens': 'var(--token-color-special-border-button-tokens)',
  'special-border-card': 'var(--token-color-special-border-card)',
  'special-border-divider': 'var(--token-color-special-border-divider)',
  'special-xchain-stroke': 'var(--token-color-special-xchain-stroke)',
  'special-border-button-red-secondary-focus':
    'var(--token-color-special-border-button-red-secondary-focus)',
  'special-content-button-tokens': 'var(--token-color-special-content-button-tokens)',
  'special-content-button-purple': 'var(--token-color-special-content-button-purple)',
  'special-content-pill-tokens': 'var(--token-color-special-content-pill-tokens)',
  'special-content-button-red-primary-disabled':
    'var(--token-color-special-content-button-red-primary-disabled)',
  'special-content-button-red-secondary-disabled':
    'var(--token-color-special-content-button-red-secondary-disabled)',
  'special-mb-success-start-color': 'var(--token-color-special-mb-success-start-color)',
  'special-mb-info-color': 'var(--token-color-special-mb-info-color)',
};
